import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ImagesContainer } from 'ZalamoLibrary/src/lib/upload/graphql';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';
import { PhotoGroupList } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/standalone';
import { UntypedFormControl } from '@angular/forms';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import {
  getPhotoGroupFromPhotoId,
  getPhotoGroupIdFromPhotoId,
} from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/helpers';
import { takeUntil, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { EditWallDecorPieceComponent } from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/edit-wall-decor-piece/edit-wall-decor-piece.component';
import { ProductType } from 'graphql/libs/product-editor/src/graphql';
import {
  ImagesInWallDecorMap,
  SingleImageInWallDecorMap,
} from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/types';
import { groupArrayByIndex } from '../../../../../../../../../helpers/array';

@Component({
    selector: 'lib-images-picker',
    templateUrl: './images-picker.component.html',
    styleUrls: ['./images-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImagesPickerComponent implements OnInit {
  @Input() context: ImagesContainer;
  @Input() contextId: ImagesContainer;
  @Input() availableImages: string[] = [];
  @Input() @Required current: string;
  @Input() @Required imageRelations: PhotoGroupList[] = [];
  @Output() picked = new EventEmitter<string>();
  @Output() cropped = new EventEmitter<{
    x: number;
    y: number;
    w: number;
    h: number;
  }>();
  @Input() ratio = 1;
  @Input() isFlip = false;
  currentCrop = new UntypedFormControl();
  @Output() saved = new EventEmitter<SingleImageInWallDecorMap[]>();
  private _photoId;
  slots$ = new BehaviorSubject([]);
  imageMap$ = new BehaviorSubject<ImagesInWallDecorMap>({});

  @Input() set currentImages(images) {
    if (images) {
      this.imageMap$.next(groupArrayByIndex(images, 'pieceId'));
    }
  }

  @Input() type: ProductType;

  set imagesCount(count) {
    this.slots$.next(Array(count).fill(0));
  }

  get photoId() {
    return this._photoId;
  }

  set photoId(value) {
    this._photoId = value;
  }

  usedPhotos: { photoId: string; photoGroupId: string; ratio: number }[] = [];

  constructor(private zalamoDialogService: ZalamoDialogService) {}

  ngOnInit(): void {
    if (this.type === ProductType.Triplex) {
      this.imagesCount = 3;
    }
  }

  editSlot(currentIndex) {
    console.log(this.imageMap$.value);
    const ref = this.zalamoDialogService.openRight(EditWallDecorPieceComponent);
    ref.componentInstance.availableImages = this.availableImages;
    ref.componentInstance.imageRelations = this.imageRelations;
    ref.componentInstance.photoId = this.imageMap$.value[currentIndex]?.photoId;
    ref.componentInstance.isFlip = this.imageMap$.value[currentIndex]?.isFlip;
    ref.componentInstance.otherImages = this.imageMap$.value;
    ref.componentInstance.currentCrop.patchValue(
      this.imageMap$.value[currentIndex]?.crop
    );

    ref.componentInstance.ratio = this.ratio;

    ref.componentInstance.saved
      .pipe(
        tap(({ photoId, crop }) => {
          const temp: Record<
            string,
            {
              photoId: string;
              pieceId: string;
              photoGroupId: string;
              crop: {
                x: number;
                y: number;
                w: number;
                h: number;
              };
              isFlip: boolean;
            }
          > = {};
          temp[currentIndex] = {
            photoId,
            pieceId: currentIndex,
            photoGroupId: getPhotoGroupIdFromPhotoId(
              photoId,
              this.imageRelations
            ),
            isFlip: this.isFlip,
            crop,
          };
          this.imageMap$.next({
            ...this.imageMap$.value,
            ...temp,
          });
          this.saved.next(Object.values(this.imageMap$.value));
          if (
            this.usedPhotos.findIndex((photo) => photo.photoId === photoId) ===
            -1
          ) {
            const details = getPhotoGroupFromPhotoId(
              photoId,
              this.imageRelations
            );
            this.usedPhotos.push({
              photoId,
              photoGroupId: getPhotoGroupIdFromPhotoId(
                photoId,
                this.imageRelations
              ),
              ratio: details.width / details.height,
            });
          }

          ref.close();
        }),
        takeUntil(ref.afterClosed())
      )
      .subscribe();
  }
}
